import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';

export default defineModule({
    id: 'bank',
    routes: [
        {
            path: '/bank',
            name: 'bank',
            meta: { requiresAuth: true },
            component: overridable('BankPage', () => import(/* webpackChunkName: "bank" */ './views/BankPage.vue'))
        }
    ],
    contributes: {
        'profile.links': [
            {
                key: 'bank',
                order: 10,
                to: '/bank',
                icon: 'images/icons/wallet.png',
                label: 'profile.bankAccount',
                desc: 'profile.manageBankAccount'
            }
        ]
    }
});
